import { lazy, Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import { getSupportedLanguages } from './config/tenants';
import Layout from './components/Layout';
import HomePage from './pages/HomePage';

const ProductPage = lazy(() => import('./pages/ProductPage'));
const CategoryPage = lazy(() => import('./pages/CategoryPage'));
const BrandPage = lazy(() => import('./pages/BrandPage'));
const SearchPage = lazy(() => import('./pages/SearchPage'));
const BrandsPage = lazy(() => import('./pages/BrandsPage'));
const CategoriesPage = lazy(() => import('./pages/CategoriesPage'));
const VendorPage = lazy(() => import('./pages/VendorPage'));
const ComparisonPage = lazy(() => import('./pages/ComparisonPage'));
const GuidesPage = lazy(() => import('./pages/GuidesPage'));
const GuidePage = lazy(() => import('./pages/GuidePage'));
const PrivacyPolicyPage = lazy(() => import('./pages/PrivacyPolicyPage'));
const TermsConditionsPage = lazy(() => import('./pages/TermsConditionsPage'));
const CookiePolicyPage = lazy(() => import('./pages/CookiePolicyPage'));
const ImprintPage = lazy(() => import('./pages/ImprintPage'));
const ReturnPolicyPage = lazy(() => import('./pages/ReturnPolicyPage'));
const ShippingPolicyPage = lazy(() => import('./pages/ShippingPolicyPage'));
const ContactPage = lazy(() => import('./pages/ContactPage'));
const NotFoundPage = lazy(() => import('./pages/NotFoundPage'));

function pageRoutes() {
  return (
    <>
      <Route index element={<HomePage />} />
      <Route path="product/:id" element={<ProductPage />} />
      <Route path="category/:category" element={<CategoryPage />} />
      <Route path="brand/:brand" element={<BrandPage />} />
      <Route path="vendor/:vendor" element={<VendorPage />} />
      {/* Shareable, indexable comparison page. /compare (no IDs) renders the empty
          state; /compare/:ids renders the side-by-side comparison. */}
      <Route path="compare" element={<ComparisonPage />} />
      <Route path="compare/:ids" element={<ComparisonPage />} />
      <Route path="guides" element={<GuidesPage />} />
      <Route path="guide/:slug" element={<GuidePage />} />
      <Route path="search" element={<SearchPage />} />
      <Route path="brands" element={<BrandsPage />} />
      <Route path="categories" element={<CategoriesPage />} />
      <Route path="privacy-policy" element={<PrivacyPolicyPage />} />
      <Route path="terms-conditions" element={<TermsConditionsPage />} />
      <Route path="cookie-policy" element={<CookiePolicyPage />} />
      <Route path="imprint" element={<ImprintPage />} />
      <Route path="return-policy" element={<ReturnPolicyPage />} />
      <Route path="shipping-policy" element={<ShippingPolicyPage />} />
      <Route path="contact" element={<ContactPage />} />
      <Route path="*" element={<NotFoundPage />} />
    </>
  );
}

function App() {
  const supportedLanguages = getSupportedLanguages();

  return (
    <Suspense fallback={<Layout />}>
      <Routes>
        {supportedLanguages.length > 1 && supportedLanguages.map(lang => (
          <Route key={lang} path={`/${lang}`} element={<Layout />}>
            {pageRoutes()}
          </Route>
        ))}
        <Route path="/" element={<Layout />}>
          {pageRoutes()}
        </Route>
      </Routes>
    </Suspense>
  );
}

export default App;
